import { useQueryClient } from '@tanstack/react-query'
import React from 'react'

import { useSurveyFiltersQueryKey } from './useSurveyFiltersQueryKey'

export const useInvalidateSurveyFiltersQuery = () => {
  const queryClient = useQueryClient()
  const queryKey = useSurveyFiltersQueryKey()

  return React.useCallback(
    () => queryClient.invalidateQueries({ queryKey }),
    [queryKey, queryClient],
  )
}
